import React from 'react';
import { motion } from 'framer-motion';

const ProgressBar = ({ progress = 0 }) => {
  const clamped = Math.min(Math.max(progress, 0), 100);
  return (
    <div className="w-full h-2 rounded-full overflow-hidden bg-[#e2e8f0]">
      <motion.div
        className="h-full rounded-full"
        style={{ background: 'linear-gradient(90deg, #3b82f6, #2563eb)' }}
        initial={{ width: 0 }}
        animate={{ width: `${clamped}%` }}
        transition={{ duration: 0.4, ease: 'easeOut' }}
      />
    </div>
  );
};

export default ProgressBar;
